/*
 * BACHGOLD SUPPORT POPUP — Premium Rev 2
 * ---------------------------------------
 * Modal-Open/Close + Scope-Visibility:
 * - Trigger zeigt nur wenn sein data-bg-supp-scope (CSS-Selector,
 *   z.B. "#faq") im Viewport sichtbar ist (IntersectionObserver).
 *   Außerhalb → trigger hidden. So bleibt er scoped auf die FAQ.
 * - ESC + Click-Outside + Focus-Trap + Body-Scroll-Lock
 * - Auto-opens wenn Form nach Submit mit Success/Error zurückkommt.
 */
(function () {
  'use strict';

  function init() {
    var roots = document.querySelectorAll('[data-bg-supp]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var modal    = root.querySelector('[data-bg-supp-modal]');
      var trigger  = root.querySelector('[data-bg-supp-open]');
      var closers  = root.querySelectorAll('[data-bg-supp-close], [data-bg-supp-backdrop]');
      if (!modal || !trigger) return;

      var lastFocus = null;
      var isOpen = false;

      function open() {
        if (isOpen) return;
        lastFocus = document.activeElement;
        modal.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('bg-supp-open');
        isOpen = true;
        setTimeout(function () {
          var firstInput = modal.querySelector('input, textarea, button:not([data-bg-supp-close])');
          if (firstInput) firstInput.focus();
        }, 260);
      }

      function close() {
        if (!isOpen) return;
        modal.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('bg-supp-open');
        isOpen = false;
        if (lastFocus && typeof lastFocus.focus === 'function') {
          lastFocus.focus();
        }
      }

      trigger.addEventListener('click', open);
      closers.forEach(function (el) { el.addEventListener('click', close); });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen) close();
      });

      // Focus-trap
      modal.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || !isOpen) return;
        var focusables = modal.querySelectorAll(
          'button, [href], input, textarea, select, [tabindex]:not([tabindex="-1"])'
        );
        if (!focusables.length) return;
        var first = focusables[0];
        var last  = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      });

      // ============ SCOPE-VISIBILITY ============
      // Trigger ist initially hidden (Liquid setzt hidden attribut).
      // Zeige nur wenn Scope-Target im Viewport.
      var scopeSel = root.getAttribute('data-bg-supp-scope');
      var scopeEl  = scopeSel ? document.querySelector(scopeSel) : null;

      if (scopeEl && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              trigger.removeAttribute('hidden');
            } else {
              // Modal erst schließen wenn noch offen (User könnte weggescrollt haben)
              if (isOpen) close();
              trigger.setAttribute('hidden', '');
            }
          });
        }, {
          root: null,
          threshold: 0.15,
          rootMargin: '0px'
        });
        io.observe(scopeEl);
      } else {
        // Fallback: immer sichtbar wenn kein Scope-Target
        trigger.removeAttribute('hidden');
      }

      // Auto-open if Shopify redirected with form-success/error
      try {
        var params = new URLSearchParams(window.location.search);
        if (params.get('contact') === '1' || window.location.hash === '#contact') {
          trigger.removeAttribute('hidden');
          open();
        }
        if (modal.querySelector('.bg-supp__msg--ok, .bg-supp__msg--err')) {
          trigger.removeAttribute('hidden');
          open();
        }
      } catch (err) { /* noop */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
